import { REGULAR_FILTERS_CHANGE, REGULAR_FILTERS_SUBMIT } from './constants'

export const regularFiltersChange = (value, filterType) => ({
  type: REGULAR_FILTERS_CHANGE,
  payload: { value, filterType },
})
export const regularFiltersSubmit = () => ({ type: REGULAR_FILTERS_SUBMIT })

export default {
  // to props
  regularFiltersChange,
  regularFiltersSubmit,
}
